import React, { useState } from "react";
import LeftMenu from '../../components/LeftMenu';
import MainHeader from '../../components/MainHeader';
import DashboardContent from './DashboardContent';

import secureLocalStorage from "react-secure-storage";
import { menuPermissionHasAccess } from '../../components/DataList';

export default function DashboardPage() {
    const [viewDashboard, setViewDashboard] = useState(true)

    React.useEffect(() => {
        (async () => {
            const menuperm = JSON.parse(secureLocalStorage.getItem('menuperm'));
            let hasUpdate = await menuPermissionHasAccess(menuperm, window.location.pathname)
            //console.log('could access page: ' + window.location.pathname + ' - ' + hasUpdate)
            if (!hasUpdate) {
                setViewDashboard(false)
            }
        })()

    }, [])

    return (
        <div className="wrapper">
            <LeftMenu />

            <div className="main-panel">
                <MainHeader pageTitle="Auto Renew Direct Debit" />

                <div className="container">
                    <div className="page-inner">
                        {viewDashboard ?
                            <DashboardContent />
                            :
                            <div className="row justify-content-md-center m-5">
                                <span className="text-success fs-3">Please select menu</span>
                            </div>
                        }
                    </div>
                </div>

            </div>
        </div>
    )
}